
import React from 'react';
import { Link } from 'react-router-dom';
import { MainLayout } from '@/components/layout/MainLayout';
import { useCategories } from '@/hooks/useCategories';
import { BookOpen, Code, Server, Shield, Cloud, Brain } from 'lucide-react';

export default function CategoriesPage() {
  const { data: categories = [], isLoading } = useCategories();
  
  // Map the icon name to the actual component
  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'code':
        return <Code className="h-6 w-6" />;
      case 'server':
        return <Server className="h-6 w-6" />;
      case 'shield':
        return <Shield className="h-6 w-6" />;
      case 'cloud':
        return <Cloud className="h-6 w-6" />;
      case 'brain':
        return <Brain className="h-6 w-6" />;
      default:
        return <BookOpen className="h-6 w-6" />;
    }
  };

  if (isLoading) {
    return (
      <MainLayout>
        <div className="container py-16 px-4 text-center">
          <div className="animate-pulse">Loading categories...</div>
        </div>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <div className="container py-16 px-4">
        <h1 className="text-3xl font-bold mb-2">Categories</h1>
        <p className="text-muted-foreground mb-8">Browse tutorials by category</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {categories.map((category: any) => (
            <Link 
              key={category.id} 
              to={`/categories/${category.id}`}
              className="block group"
            >
              <div className="border rounded-lg p-6 h-full transition-all group-hover:shadow-md">
                <div className="flex items-center gap-4">
                  <div className="bg-primary/10 p-3 rounded-full text-primary">
                    {getIconComponent(category.icon)}
                  </div>
                  <div>
                    <h3 className="font-medium text-lg">{category.name}</h3>
                    <p className="text-sm text-muted-foreground mt-1">
                      {category.tutorialIds?.length || 0} tutorials
                    </p>
                  </div>
                </div>
                <p className="mt-4 text-muted-foreground">{category.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}
